import React from "react";
import { Link } from "react-router-dom";
import { LifeBuoy, ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n";

export function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="border-t border-softpink bg-white px-5 py-14 sm:px-8">
      <div className="mx-auto flex max-w-5xl flex-col gap-8 md:flex-row md:items-end md:justify-between">
        <div className="max-w-md">
          <div className="flex items-center gap-2.5">
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-dusty text-white">
              <span className="h-2 w-2 rounded-full bg-white" />
            </span>
            <span className="text-sm font-semibold text-graphite">
              Anonymous Violence Support Program
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-textsec">{t("footer_note")}</p>
        </div>
        <Link
          to="/resources"
          data-testid="footer-resources-link"
          className="group inline-flex items-center gap-3 rounded-panel bg-softpink px-5 py-4 shadow-soft transition-transform hover:-translate-y-0.5"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-dusty">
            <LifeBuoy size={20} strokeWidth={1.5} />
          </span>
          <span>
            <span className="block text-sm font-semibold text-graphite">{t("footer_need_help")}</span>
            <span className="block text-xs text-textsec">{t("footer_resources")}</span>
          </span>
          <ArrowUpRight size={18} strokeWidth={1.5} className="text-dusty transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
      <div className="mx-auto mt-10 max-w-5xl border-t border-softpink pt-5 text-center">
        <Link
          to="/admin"
          data-testid="footer-admin-link"
          className="text-xs text-textsec/60 transition-colors hover:text-dusty"
        >
          {t("moderation")}
        </Link>
      </div>
    </footer>
  );
}
